export default __webpack_public_path__ + "media/images/icons/check-icon-c06640f2b22a938ce0409de40f45a2bb.svg";